import React from 'react';
import { VStack } from '@chakra-ui/react';
import { Box, Text, Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react';

const Alerts = () => {
  const alerts = [
    {
      projectName: 'Pulse',
      subject: 'Andy created a task work item',
      date: '21-01-2026',
    },
    {
      projectName: 'VTS',
      subject: 'Andy created a Epic work item',
      date: '21-01-2026',
    },
    {
      projectName: 'SAM',
      subject: 'Andy created a task work item',
      date: '21-01-2026',
    },
    {
      projectName: 'GWC',
      subject: 'Andy created a Epic work item',
      date: '21-01-2026',
    },
    {
      projectName: 'Eagle',
      subject: 'Andy created a Epic work item',
      date: '21-01-2026',
    },
  ];

  return (
    <>
      <VStack align="stretch" spacing={2}>
        <Text fontSize="lg" fontWeight="semibold" mb={0}>
          Alerts & Notifications
        </Text>
        <Box
          bg="white"
          borderRadius="lg"
          p={6}
          boxShadow="sm"
          borderWidth="1px"
          borderColor="gray.200"
          h="310px" // Fixed height for the alerts section
          display="flex"
          flexDirection="column"
        >
          <Box overflowY="auto" maxH="full">
            <Table variant="simple" size="sm" zIndex={0}>
              <Thead
                position="sticky"
                top={0}
                bg="white"
                zIndex={0}
                borderColor="gray.200"
              >
                <Tr>
                  <Th
                    fontSize="xs"
                    fontWeight="600"
                    color="gray.600"
                    textTransform="none"
                    borderColor="gray.200"
                  >
                    Project Name
                  </Th>
                  <Th
                    fontSize="xs"
                    fontWeight="600"
                    color="gray.600"
                    textTransform="none"
                    borderColor="gray.200"
                  >
                    Subject
                  </Th>
                  <Th
                    fontSize="xs"
                    fontWeight="600"
                    color="gray.600"
                    textTransform="none"
                    borderColor="gray.200"
                  >
                    Date
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {alerts.map((alert, index) => (
                  <Tr
                    key={index}
                    _hover={{ bg: 'gray.50' }}
                    transition="background 0.2s"
                  >
                    <Td
                      fontSize="sm"
                      fontWeight="500"
                      color="gray.700"
                      borderColor="gray.200"
                    >
                      {alert.projectName}
                    </Td>
                    <Td fontSize="sm" color="gray.600" borderColor="gray.200">
                      {alert.subject}
                    </Td>
                    <Td fontSize="sm" color="gray.600" borderColor="gray.200">
                      {alert.date}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
        </Box>
      </VStack>
    </>
  );
};

export default Alerts;
